import { render, staticRenderFns } from "./DefaultPageNumber.vue?vue&type=template&id=2ba38cdb&scoped=true&"
import script from "./DefaultPageNumber.vue?vue&type=script&lang=js&"
export * from "./DefaultPageNumber.vue?vue&type=script&lang=js&"
import style0 from "./DefaultPageNumber.vue?vue&type=style&index=0&id=2ba38cdb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba38cdb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VIcon,VList,VListItem,VListItemTitle,VMenu})
